/* eslint-disable react-hooks/exhaustive-deps */

import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import ShowQuestion from "../submodule/src/App";
import { addQuestion, getChat } from "../submodule/src/api/QuestionsApi";
import logo from "../logo.svg";
import parameters from "../utils/parameters";

const Question = () => {
  const { i18n } = useTranslation();
  const [currentLanguage, setCurrentLanguage] = useState(i18n.language);
  const { id } = useParams();
  const [chat, setChat] = useState("");

  const otherReferences = false;

  const selectedQuestion = async () => {
    try {
      const chat = await getChat(id);
      setChat(chat);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    selectedQuestion();
  }, []);

  useEffect(() => {
    const handleLanguageChange = () => {
      setCurrentLanguage(i18n.language);
    };

    i18n.on("languageChanged", handleLanguageChange);

    return () => {
      i18n.off("languageChanged", handleLanguageChange);
    };
  }, [i18n]);

  return (
    <div className="w-11/12 mx-auto">
      <ShowQuestion
        retrievalId={id}
        addQuestionRetData={addQuestion}
        logo={logo}
        chat={chat}
        otherRefs={otherReferences}
        matrix_mode={true}
        colors={parameters.componentColors}
        allow_files={true}
        language={currentLanguage}
      />
    </div>
  );
};

export default Question;
